import { render, staticRenderFns } from "./FinanceLoans.vue?vue&type=template&id=12b61edb"
import script from "./FinanceLoans.vue?vue&type=script&lang=js"
export * from "./FinanceLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports